export default function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/utils/is-date.js